import React from "react";
import {NavLink, useNavigate} from "react-router-dom";
import * as Utils from "../inc/Utils";
import {Config} from "../Config";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";

export default function EditProfile(prop) {
    let navigate = useNavigate();

    let member = prop.member;
    let [data, setData] = React.useState(null);

    let [disabledBtn, setDisabledBtn] = React.useState(false);
    let [memberTypeId, setMemberTypeId] = React.useState(null);
    let [departmentTypeId, setDepartmentTypeId] = React.useState(null);
    let [department, setDepartment] = React.useState(null);
    let [departmentId, setDepartmentId] = React.useState(null);
    let [prefix, setPrefix] = React.useState(null);
    let [prefixId, setPrefixId] = React.useState(null);
    let [appliedResearch, setAppliedResearch] = React.useState(null);
    let [basicResearch, setBasicResearch] = React.useState(null);

    let refIdcard = React.useRef();
    let refFirstname = React.useRef();
    let refLastname = React.useRef();
    let refEmail = React.useRef();
    let refPhone = React.useRef();

    React.useEffect(() => {
        window.scrollTo(0, 0);

        document.title = 'แก้ไขข้อมูลส่วนตัว - NCSA';

        (async function() {
            try {
                if(member) {
                    const resView = await Utils.getProfile(member);
                    setData(resView);
                    refIdcard.current.value = resView.idcard;
                    refFirstname.current.value = resView.firstname;
                    refLastname.current.value = resView.lastname;
                    refEmail.current.value = resView.email;
                    refPhone.current.value = resView.phone;

                    setMemberTypeId(resView.memberTypeId);
                    setBasicResearch(resView.basicResearch===1);
                    setAppliedResearch(resView.appliedResearch===1);
                    setDepartmentTypeId(resView.departmentTypeId);

                    const resDepartment = await getDepartment();
                    setDepartment(resDepartment);
                    const resPrefix = await getPrefix();
                    setPrefix(resPrefix);

                    if(resPrefix && resView.prefixId) {
                        setPrefixId(resView.prefixId);
                    }
                    if(resDepartment && resView.departmentId) {
                        setDepartmentId(resView.departmentId);
                    }
                }
            } catch (e) {
                //
            }
        })();

    }, []);

    const onReset = () => {
        navigate((prop.lang === 'en' ? '/en':'/') + 'profile');
    };

    const onSubmit = async () => {
        let idcard = refIdcard.current.value;
        let firstname = refFirstname.current.value;
        let lastname = refLastname.current.value;
        let email = refEmail.current.value;
        let phone = refPhone.current.value;

        if(member.typeId === Utils.MEMBER_TYPE_RESEARCHER && departmentTypeId === Utils.MEMBER_DEPARTMENT_YES && departmentId === null) {
            toast.error(prop.lang === 'en' ? 'Please specify department':'กรุณาระบุ กระทรวง/สังกัด');
        }
        // else if(!idcard || isNaN(idcard) || idcard.length !== 13) {
        //     toast.error(prop.lang === 'en' ? 'Please specify 13-digit national ID number.':'กรุณาระบุ ระบุเลขประจำตัวประชาชน ตัวเลข 13 หลัก');
        //     refIdcard.current.focus();
        // }
        // else if(!prefixId) {
        //     toast.error(prop.lang === 'en' ? 'Please specify Prefix':'กรุณาระบุ คำนำหน้านาม');
        // }
        // else if(firstname === '') {
        //     toast.error(prop.lang === 'en' ? 'Please specify Firstname':'กรุณาระบุ ชื่อจริง');
        //     refFirstname.current.focus();
        // }
        // else if(lastname === '') {
        //     toast.error(prop.lang === 'en' ? 'Please specify Lastname':'กรุณาระบุ นามสกุล');
        //     refLastname.current.focus();
        // }
        // else if(email === '' || !Utils.validateEmail.test(email)) {
        //     toast.error(prop.lang === 'en' ? 'Please specify a valid email':'กรุณาระบุ รูปแบบอีเมลให้ถูกต้อง');
        //     refEmail.current.focus();
        // }
        else if(!phone || isNaN(phone) || phone.length !== 10) {
            toast.error(prop.lang === 'en' ? 'Please specify 10-digit Phone number.':'กรุณาระบุ ระบุเบอร์โทรศัพท์ ตัวเลข 10 หลัก');
            refPhone.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ยืนยันการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setDisabledBtn(true);
                            let param = {
                                memberTypeId: memberTypeId,
                                departmentTypeId: departmentTypeId,
                                departmentId: departmentTypeId === Utils.MEMBER_DEPARTMENT_YES ? departmentId : null,
                                basicResearch: basicResearch ? 1:null,
                                appliedResearch: appliedResearch ? 1:null,
                                currentEmail: data.email,
                                email: data.email,
                                phone: phone,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await updateMember(param);
                            if(result) {
                                setDisabledBtn(false);
                                if(result.status === 'success') {
                                    toast.success(prop.lang === 'en' ? 'Update profile successfully':'อัพเดตโปรไฟล์เรียบร้อย');
                                    setTimeout(function () {
                                        navigate((prop.lang === 'en' ? '/en':'/') + 'profile');
                                    }, 1500);
                                }
                                else if(result.status === 'email') {
                                    toast.error(prop.lang === 'en' ? 'Email already exists':'ขออภัย อีเมลนี้ถูกใช้งานไปแล้ว กรุณาระบุอีเมลใหม่');
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function getDepartment () {
        const response = await fetch(Config.apiUrl +'/department/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getPrefix() {
        const response = await fetch(Config.apiUrl +'/prefix/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function updateMember(param) {
        const response = await fetch(Config.apiUrl +'/member/updateMember', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onChangePrefix = (x) => {
        setPrefixId(x.target.value);
    };

    const onChangeDepartment = (x) => {
        setDepartmentId(x.target.value);
    };

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="profile" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">

                            {
                                member.typeId === Utils.MEMBER_TYPE_RESEARCHER ?
                                    <>
                                        <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Research Information':'ข้อมูลการวิจัย'}</h3>

                                        <h6 className="pb-3">{prop.lang === 'en' ? 'Member Type':'ประเภทผู้สมัคร'}</h6>
                                        <div className="row">
                                            <div className="col-md-4 col-sm-6">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" id="radio1_1" name="radio1" onChange={e => setMemberTypeId(Utils.MEMBER_TYPE_REASEARCHER)} checked={memberTypeId === Utils.MEMBER_TYPE_REASEARCHER} />
                                                    <label className="form-check-label" htmlFor="radio1_1">{prop.lang === 'en' ? 'Researcher':'นักวิจัย'}</label>
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-6">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" id="radio1_2" name="radio1" onChange={e => setMemberTypeId(Utils.MEMBER_TYPE_ENTREPRENEUR)} checked={Utils.MEMBER_TYPE_ENTREPRENEUR === memberTypeId} />
                                                    <label className="form-check-label" htmlFor="radio1_2">{prop.lang === 'en' ? 'Entrepreneur/Agency':'ผู้ประกอบการ/หน่วยงาน'}</label>
                                                </div>
                                            </div>
                                        </div>

                                        <h6 className="pb-3 mt-4">{prop.lang === 'en' ? 'Belong To Type':'ประเภทสังกัด'}</h6>
                                        <div className="row">
                                            <div className="col-md-4 col-sm-6">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" value="" id="radio2_1" name="radio2" onChange={e => setDepartmentTypeId(Utils.MEMBER_DEPARTMENT_YES)} checked={Utils.MEMBER_DEPARTMENT_YES === departmentTypeId} />
                                                    <label className="form-check-label" htmlFor="radio2_1">{prop.lang === 'en' ? 'Specify':'ระบุสังกัด'}</label>
                                                </div>
                                            </div>

                                            <div className="col-md-4 col-sm-6">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="radio" value="" id="radio2_2" name="radio2" onChange={e => setDepartmentTypeId(Utils.MEMBER_DEPARTMENT_NO)} checked={Utils.MEMBER_DEPARTMENT_NO === departmentTypeId} />
                                                    <label className="form-check-label" htmlFor="radio2_2">{prop.lang === 'en' ? 'Not specified':'ไม่ระบุสังกัด'}</label>
                                                </div>
                                            </div>
                                        </div>

                                        <h6 className="pb-2 mt-4">{prop.lang === 'en' ? 'Select Department':'กระทรวง/สังกัด'} <span className="star">*</span></h6>
                                        <select className="form-select" value={departmentId} onChange={onChangeDepartment} disabled={departmentTypeId === Utils.MEMBER_DEPARTMENT_NO}>
                                            <option value="">กรุณาเลือก</option>
                                            {
                                                department !== null && department.count > 0 ?
                                                    department.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    }) : ''
                                            }
                                        </select>

                                        <h6 className="pb-3 mt-4">{prop.lang === 'en' ? 'Research Type':'ประเภทของการวิจัย'}</h6>
                                        <div className="row g-3">
                                            <div className="col-12">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="checkbox" value="" id="radio3_1" name="radio3" onChange={e => setBasicResearch(!basicResearch)} checked={basicResearch} />
                                                    <label className="form-check-label" htmlFor="radio3_1">
                                                        {prop.lang === 'en' ? 'Not specified':'ไม่ระบุสังกัด'}การวิจัยพื้นฐาน (Basic Research)
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="checkbox" value="" id="radio3_2" name="radio3" onChange={e => setAppliedResearch(!appliedResearch)} checked={appliedResearch} />
                                                    <label className="form-check-label" htmlFor="radio3_2">
                                                        {prop.lang === 'en' ? 'Not specified':'ไม่ระบุสังกัด'}การวิจัยประยุกต์ (Applied Research)
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="py-3">
                                            <hr />
                                        </div>
                                    </> : ''
                            }

                            <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Profile':'ข้อมูลส่วนตัว'}</h3>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Id Card Number':'ระบุเลขประจำตัวประชาชน'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refIdcard} placeholder={prop.lang === 'en' ? '13-digit national ID number':'ตัวเลข 13 หลัก'} maxLength={13} disabled={true} />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Prefix':'คำนำหน้านาม'} <span className="star">*</span></h6>
                                        <select className="form-select" value={prefixId} onChange={onChangePrefix} disabled={true}>
                                            <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                            {
                                                prefix !== null && prefix.count > 0 ?
                                                    prefix.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    }) : ''
                                            }
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Firstname':'ชื่อจริง'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refFirstname} maxLength={100} disabled={true} />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Lastname':'นามสกุล'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refLastname} maxLength={100} disabled={true} />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Email':'อีเมล'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refEmail} placeholder={prop.lang === 'en' ? 'ex. your@mail.com':'เช่น your@mail.com'} maxLength={100} disabled={true} />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Phone':'หมายเลขโทรศัพท์มือถือ'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refPhone} placeholder={prop.lang === 'en' ? '10-digit national ID number':'ตัวเลข 10 หลัก'} maxLength={10} />
                                    </div>
                                </div>
                            </div>

                            <div className="buttons gap-15 pb-0 my-sm-4">
                                <button className="btn btn-gray w-130" type="button" onClick={onReset}>
                                    {prop.lang === 'en' ? 'Reset':'ยกเลิก'}
                                </button>
                                <button className="btn btn-primary w-130" type="button" onClick={onSubmit} disabled={disabledBtn}>
                                    {prop.lang === 'en' ? 'Update':'อัพเดต'}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 